<div class="new_product_page">
    <div class="product_page_div">
        <div class="bg-img">
            <img src="assets/img/login/new-bg.png" alt="bg-image">
        </div>
        <div class="product_login_card_div">
            <div class="product_login_card">
                <div class="card-logo">
                    <img src="assets/img/login/new_logo.png" alt="logo" />
                </div>
                <div class="card-title">
                    <h4 class="text-center">Reset Password</h4>
                    <p class="text-center m-0">Please enter your registered e-mail address</p>
                </div>
                <form [formGroup]="forgetPasswordForm" class="authentication-form">
                    <div class="mb-3">
                        <input type="email" formControlName="email" class="form-control" placeholder="Enter your email" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" required />
                        <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                            <div *ngIf="f.email.errors.required">Email is required</div>
                        </div>
                    </div>
                    <button class="btn btn-info btn-block mb-3" (click)="onSubmit()">Reset Password</button>
                    <div class="col-md-12 text-center">
                        <a [routerLink]="'/auth/login'" class="text-infor">Back to login Page</a>
                    </div>
                </form>
            </div>
        </div>
        <p class="powrd-by">Designed, Developed & Powered By Amnex Infotechnologies Pvt Ltd.</p>
    </div>
</div>

<div class="container" id="bg-login" *ngIf="false">
    <div class="row">
        <div class="col-md-6 center-center">
            <img src="assets/img/login/AMNEX Logo-blue.svg" width="400" alt="login" />
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-4 d-flex align-items-center">
            <form [formGroup]="forgetPasswordForm" class="font-9 py-3">
                <div class="text-center mb-5">
                    <!-- <img src="assets/img/login/osrtclogo.jpg" class="pb-4 logo" alt="login" /> -->
                    <img src="assets/img/login/MDB_LOGO.png"class="pb-4 logo" alt="login" />
                    <h3 class="mt-5">Reset Password</h3>
                </div>
                <div class="mb-3 mt-3">
                    <label for="email" class="form-label">Please enter your registered e-mail address</label>
                    <input type="email" formControlName="email" class="form-control mt-2" placeholder="Enter your email" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" required />
                    <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                        <div *ngIf="f.email.errors.required">Email is required</div>
                    </div>
                </div>
                <br />

                <button class="btn btn-info btn-block" (click)="onSubmit()">Reset Password</button>
                <br />
                <div class="row">
                    <div class="col-md-12 text-center">
                        <a [routerLink]="'/auth/login'" class="text-infor">Back to login Page</a>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- 

<div class="container "  id="bg-login">
    <div class="row">
        <div class="col-md-8 center-center">
            <img src="assets/img/login/AMNEX Logo-blue.svg" width="400" alt="login">
        </div>
        <div class="col-md-4 ">
            <div class="text-center">
                <img src="assets/img/login/XUP.svg" alt="login">
                <h3 class="pt-5">Welcome</h3>
                <p class="font-9 font-w">Reset Password</p>
            </div>
           
            <form [formGroup]="forgetPasswordForm" class="font-9">
                <div class="mb-3 mt-3">
                  <label for="email" class="form-label">Please enter your registered e-mail address</label>
                  <input 
                  type="email" 
                  formControlName="email" 
                  class="form-control"
                  placeholder="Enter your email"
                  [ngClass]="{ 'is-invalid': submitted && f.email.errors }"
                   required />
                  <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                      <div *ngIf="f.email.errors.required">Email is required</div>
                  </div>
                </div>
               <br>
               
                
                <button class="btn btn-info btn-block" (click)="onSubmit()">Reset Password</button>
                <br>
                <div class="row">
                    <div class="col-md-5">
                        
                    </div>
                    <div class="col-md-7 text-end">
                        <a [routerLink]="'/auth/login'"class="text-infor">Back to login Page</a>
                    </div>
                </div>
                
              </form>
              <div class="text-center pt-5">
                <img src="assets/img/login/Powered by AMNEX.svg" width="110" alt="login">
              </div>
        </div>
    </div>
</div> -->
